import getInitialValues, { BaseConfig, Nullable, Schema, Result as SchemaResult } from '.'

export type Config = BaseConfig & {
  type: 'schema'
  schema: Schema
} & (
    | {
        nullable?: true
        defaultValue?: SchemaResult<Config['schema']>
      }
    | {
        nullable: false
        defaultValue: SchemaResult<Config['schema']>
      }
  )

export type Result<T extends Config> = Nullable<T, T['array'] extends true ? Array<SchemaResult<T['schema']>> : SchemaResult<T['schema']>>

const transformValue = (value: any, config: Config): SchemaResult<Config['schema']> | null => {
  const nullable = config?.nullable ?? true
  const defaultValue = nullable ? config?.defaultValue ?? null : (config?.defaultValue as SchemaResult<Config['schema']>)

  if (value === null) {
    return nullable ? null : defaultValue
  }
  if (typeof value !== 'object' || Array.isArray(value)) {
    return defaultValue
  }

  return getInitialValues(value, config.schema)
}

export const transform = (value: any, config: Config): SchemaResult<Config['schema']> | Array<SchemaResult<Config['schema']>> | null => {
  const array = config.array ?? false

  if (array) {
    if (!Array.isArray(value)) {
      return []
    }

    return value.map((item) => transformValue(item, config)).filter(Boolean) as Array<SchemaResult<Config['schema']>>
  }

  return transformValue(value, config)
}
